import axios from 'axios';
import * as THREE from "three";

import React, { useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import IconButton from "@material-ui/core/IconButton";
import HelpIcon from '@material-ui/icons/Help';

import { GreyCheckbox } from '../style/customUI';
import SideStyle from '../style/sideStyle';
// import { StartWithMesh, Check, GetSTL, GetJSON, GetLog } from "../fileIO/post";
// import { Array2Vpoints } from "../shape/Adapter";
import Param from '../store/param';
import Control from '../store/control';
import { AddIcon } from '../formAk/formUtil';
// import { POLLING_INTERVAL1 } from '../store/global';
import * as helptext from './helptext';

const FormCompress = () => {
  const SetCameraFront  = Control.Get("SetCameraFront");
  const SetCameraFree = Control.Get("SetCameraFree");

  const style      = SideStyle();
  const compress   = Param.Get("compress");
  const setParam   = Param.Get("setParam");
  const setControl = Control.Get('setControl');
  const meshLeg    = Control.Get("meshLeg");
  const showBound  = Control.Get("showBound");
  const showLine   = Control.Get("showLine");
  const oriPointCross = Control.Get("oriPointCross");
  
  const max_line_count = compress.line_count;

  useEffect(() => {
    SetCameraFront();
    //SetCameraFree();
    setParam(s => {s.instructionText = "Ajust the compression, and go to [Modifying]"});
  }, [])

  // function getLines(){
  //   var lines = [];
  //   for(var i=0; i<compress.line_count; i++){
  //     var obj = {"smooth": Number(compress.smoothness[i]), 
  //               "compression": Number(compress.compression[i])}
  //     lines.push(obj);
  //   }
  //   return lines;
  // }
  // function getHeight(){
  //   meshLeg.geometry.computeBoundingBox();
  //   var bBox = meshLeg.geometry.boundingBox;
  //   var height = bBox.max.z - bBox.min.z;
  //   return height;
  // }

  // function getMaxLineCount(){
  //   const h = getHeight();
  //   const line_count = Math.floor(h / compress.interval);
  //   SetParam(s => {s.compress.line_count = line_count});
  //   console.log("max_line_count", line_count);
  //   return line_count;
  // }

  // function getLengthFromPlines(plines){
  //   var vlines = [];
  //   var lengths = [];
  //   for (var i = 0; i < plines.length; i++) {
  //     var parray = plines[i];
  //     //var vp = Array2Vpoints(parray);

  //     //add first point to last to close line
  //     vp.push(vp[0]);

  //     var len = 0;
  //     for (var j = 0; j < vp.length - 1; j++) {
  //       len += vp[j].distanceTo( vp[j+1] );
  //     }
  //     vlines.push(vp);
  //     lengths.push(len);
  //   }
  //   return [vlines, lengths];
  // }



  const insertValue = (array, part, addValue) => {
    var tmp = [];
    for(var i = 0; i < array.length; i += part) {
        if (addValue) {
          tmp.push(addValue, ...array.slice(i, i + part));
        } else {
          tmp.push(array.slice(i, i + part));
        }
    }
    return tmp;
  }

  const onCreateSocket = () => {
    if (process.env.REACT_APP_CALC_MODE == 0) { // local calculation
      setParam(s => {s.compress.step = 1})
    } else if (process.env.REACT_APP_CALC_MODE == 1) { // server calculation

      console.log('onCreateSocket');
    }
    // const mes = {
    //   "filepath": "input.stl",
    //   "pre_smoother": 5,
    //   "interval": Number(compress.interval),
    //   "line_count": Number(compress.line_count),
    //   "bottom_extension": Number(compress.extention),
    //   "verticle": 6,
    //   "offset": 10,
    //   "bottom_ext_pos": 2,
    //   "bottom_ext_type": 1,
    //   "bottom_circ_radius": 10.0,
    //   "delta_lon_min": 2.0,
    //   "delta_lon_max": 15.0,
    //   "debug_out_vtp": false,
    //   "debug_out_brep": false,
    //   "num_lon": 40,
    //   "num_lat": 20,
    //   "baseface_smooth": 5,
    //   "output_points": 80,
    //   "lines": getLines()
    // };
    // StartWithMesh( mes, 'f10', meshLeg, CallStart, CallError); 

  };

  const onCreateCross = useCallback((target) => {
    setParam(s => {s.compress.step = 1})

    if (process.env.REACT_APP_CALC_MODE == 0) { // local calculation
      console.log('onCreateCross local');

    } else if (process.env.REACT_APP_CALC_MODE == 1) { // server calculation
      console.log('onCreateCross server');
      // mesh leg
      var vertexArray = [];
      var polyArray = [];

      vertexArray = meshLeg.geometry.attributes.position.array;
      polyArray = insertValue(meshLeg.geometry.index.array, 3, 3);

      // axios settings
      const url  = process.env.REACT_APP_BACKEND_SERVER + '/api/compress';
      console.log('url', url);
      const data = {
        'vertexArray': vertexArray,
        'polyArray': polyArray,
        'compressionWhole': Number(compress.compressionWhole),
        'interval': Number(compress.interval),
        'smoothnessWhole': Number(compress.smoothnessWhole),
        'bottomExtension': Number(compress.bottomExtension),
      };
      const header = {
        headers: {
          //'Content-Type': 'multipart/form-data'
          'Content-Type': 'application/json',
          //'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      axios.post(url, data, header)
      //axios.get(url)
      .then(res => {
        console.log('get data from server to client');

        const axis = new THREE.Vector3( 1, 0, 0 );
        const angle = -Math.PI / 2;
        const pointCrossAll = res.data['point'];
        const lineCrossAll = res.data['line'];
        const merdianPointsAll =  res.data['merdianPoints'];
        const merdianLinesAll =  res.data['merdianLines'];

        var points = [];
        var pointsAlign = [];
        const pointsAll = []; // cross section
        const pointsAlignAll = []; // cross section
        const pointsMerdianAll = []; // merdian
        const pointsMerdianAlignAll = []; // merdian

        // cross section
        for (var i = 0; i < pointCrossAll.length; i++) {
          points = []
          var pointCross = pointCrossAll[i];
          if (pointCross.length == 0 ) {
            continue
          }

          for (var j = 0; j < pointCross.length; j++) {
            var p = new THREE.Vector3(...pointCross[j]);
            p.applyAxisAngle(axis, angle);
            points.push(p);
          }
          pointsAll.push(points)
        }

        for (var i = 0; i < lineCrossAll.length; i++) {
          pointsAlign = []
          var lineCross = lineCrossAll[i];
          if (lineCross.length == 0 ) {
            continue
          }
          for (var j = 0; j < lineCross.length; j++) {
            var idxLine = lineCross[j];
            pointsAlign.push(pointsAll[i][idxLine[0]]);
            pointsAlign.push(pointsAll[i][idxLine[1]]);
          }
          pointsAlignAll.push(pointsAlign);
        }

        setControl(s => {s.pointCross = pointsAlignAll});
        setParam(s => {s.compress.line_count = pointsAlignAll.length});


        // merdian
        for (var i = 0; i < merdianPointsAll.length; i++) {
          points = []
          var merdianPoints = merdianPointsAll[i];
          if (merdianPoints.length == 0 ) {
            continue
          }

          for (var j = 0; j < merdianPoints.length; j++) {
            var p = new THREE.Vector3(...merdianPoints[j]);
            p.applyAxisAngle(axis, angle);
            points.push(p);
          }
          pointsMerdianAll.push(points)
        }

        for (var i = 0; i < merdianLinesAll.length; i++) {
          pointsAlign = []
          var line = merdianLinesAll[i];
          if (line.length == 0 ) {
            continue
          }
          for (var j = 0; j < line.length; j++) {
            var idxLine = line[j];
            pointsAlign.push(pointsMerdianAll[i][idxLine[0]]);
            pointsAlign.push(pointsMerdianAll[i][idxLine[1]]);
          }
          pointsMerdianAlignAll.push(pointsAlign);
        }

        setControl(s => {s.pointMerdian = pointsMerdianAlignAll});


        // socket mesh surface
        if (true) {
          const socketVertices = res.data['socketVertices'];
          const socketFaces = res.data['socketFaces'];

          var vertices = [];
          var faces = [];
          var face = [];
          var nFace = [];
          var temp = [];

          // convert to numpy array to three array
          for (var i = 0; i < socketVertices.length; i++) {
            var p = new THREE.Vector3(...socketVertices[i]);
            vertices.push(p);
          }

          // convert to numpy array to three array
          for (var i = 0; i < socketFaces.length; i++) {
            nFace = socketFaces[i];
            face = socketFaces.slice(i+1, i+nFace+1);

            if (nFace==3) {
              //faces.push(new THREE.Face3(...face)); // this is for geometry format, but departed and not working well
              faces.push(...face) // this is for buffergeometry
            } else if (nFace==4) { // devide quad mesh into two triangle mesh
              temp = [face[0], face[1], face[2]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // this is for buffergeometry
              temp = [face[0], face[2], face[3]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // // this is for buffergeometry
            }
            i += nFace;
          }

          var temp = {
            vertices: res.data['socketVertices'],
            faces: res.data['socketFaces'],
          };

          console.log(temp)
          setControl(s => {s.meshSocketCompressVtk = temp});

          var temp = {
            vertices: vertices,
            faces: faces,
          };

          console.log(temp)
          setControl(s => {s.meshSocketCompress = temp});
        }
      })
      .catch(err => {
        console.log('error');
      });
    }
  })

  const onClear = () => {
    setParam(s => {s.compress.step = 0})
  };

  const handleValue = (e) => {
    setParam(s => {s.compress[e.target.name] = Number(e.target.value)});
  };

  const handleValueCompressionWhole = (e) => {
    setParam(s => {s.compress[e.target.name] = Number(e.target.value)});
    // set individual compression
    for (var i = 0; i < compress.line_count; i++) {
      setParam(s => {s.compress.compression[i] = Number(e.target.value)});
    }
  };

  const handleValueRadiusWhole = (e) => {
    setParam(s => {s.compress[e.target.name] = Number(e.target.value)});
    // set individual compression
    // we will calculate compression from radius
    for (var i = 1; i < compress.line_count; i++) { // 0 is bottom, so skip
      const curveLength = new THREE.CatmullRomCurve3(oriPointCross[i]).getLength();
      const radius = curveLength / (2 * Math.PI);
      const targetCurveLength = (radius + Number(e.target.value)) * 2 * Math.PI;

      setParam(s => {s.compress.compression[i-1] = 100 + (targetCurveLength - curveLength) / curveLength * 100});
    }
  };

  const handleValueSmoothnessWhole = (e) => {
    const nSmoothness = compress.smoothness.length;
    for (var i = 0; i < nSmoothness; i++) {
      setParam(s => {s.compress.smoothness[i] = Number(e.target.value)});
    }
  };

  const handleValueS = (e) => {
    setParam(s => {s.compress[e.target.name][s.compress.line_no-1] = Number(e.target.value)});
  };

  const handleCheck = (e) => {
    setControl(s => {s[e.target.name]=e.target.checked});
  };


  const getDisabled = (step) => {
    return !(compress.step == step);
  }

  const IndividualSetting = () => {
    const objects = [];

    for (var i = 1; i < compress.line_count; i++) {
      objects.push(
        (compress.line_no == i) && 
        <>
          <TextField
            key={i+'c'}
            id="filled-number"
            name='compression'
            label="Compression individual"
            type="number"
            defaultValue={Math.round(compress.compression[compress.line_no-1] * 10) / 10}
            fullWidth
            onBlur={handleValueS}
            InputProps={{
              endAdornment: 
              <AddIcon 
                unit='%'
                title='Compression Individual'
                helptext={helptext.compressionIndividual}
                imgSrc='./static/bk/img/compressionIndividual0.png'
                imgSrc1='./static/bk/img/compressionIndividual1.png'
              />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:80,
              max:120,
              step:1
            }}
          />
          <TextField
            key={i+'s'}
            id="filled-number"
            name='smoothness'
            label="Smoothness"
            type="number"
            defaultValue={compress.smoothness[compress.line_no-1]}
            fullWidth
            onBlur={handleValueS}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:1, 
              max:10,
              step:1
            }}
          />
        </>
      )
    }

    return objects
  }


  return (
    <div className={style.outside}>
      {/*
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <FormControlLabel
              control={<GreyCheckbox checked={showLine} onChange={handleCheck} name="showLine"/>}
              label="Show Circle Lines"
            />
          </FormControl>
        </Grid>
      </Grid>
      */}
      {/* Whole Setting */}
      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Whole Setting</Grid>
      </Grid>
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <TextField
          id="filled-number"
          name='interval'
          label="Interval"
          type="number"
          defaultValue={compress.interval}
          fullWidth
          onBlur={handleValue}
          InputProps={{
            //https://codesandbox.io/s/69554151-how-to-change-material-ui-textfield-inputadornment-background-color-b8kqn?file=/demo.js
            //https://stackoverflow.com/questions/56811449/how-to-style-adornment-in-mui-textfield 
            endAdornment:
              <AddIcon 
                unit='mm' 
                helptext={helptext.interval}
                title='Interval'
                imgSrc='./static/bk/img/interval.png'
              />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0, 
            max:50,
            step:1
          }}
        />
        <TextField
          id="filled-number"
          name='compressionWhole'
          label="(Option A) Compression"
          type="number"
          defaultValue={compress.compressionWhole}
          fullWidth
          onBlur={handleValueCompressionWhole}
          InputProps={{
            endAdornment:
              <AddIcon 
                unit='%'
                helptext={helptext.compression}
                title='compression'
              />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:80, 
            max:120,
            step:1
          }}
        />
        <TextField
          id="filled-number"
          name='radiusWhole'
          label='(Option B) Radius'
          type='number'
          defaultValue={compress.radiusWhole}
          fullWidth
          onBlur={handleValueRadiusWhole}
          InputProps={{
            endAdornment:
              <AddIcon 
                unit='mm'
                helptext=''
                title='Radius Whole'
              />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-100, 
            max:100,
            step:1
          }}
        />
        <TextField
          key='smoothnessWhole'
          id="filled-number"
          name='smoothnessWhole'
          label="Smoothness"
          type="number"
          defaultValue={compress.smoothnessWhole}
          fullWidth
          onBlur={handleValueSmoothnessWhole}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:1, 
            max:10,
            step:1
          }}
        />
        <TextField
          id="filled-number"
          name='bottomExtension'
          label="Bottom Extension"
          type="number"
          defaultValue={compress.bottomExtension}
          fullWidth
          onBlur={handleValue}
          InputProps={{
            endAdornment:
            <AddIcon 
              unit='mm' 
              helptext={helptext.bottomExtension}
              title='Bottom Extension'
            />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0, 
            max:100,
            step:1
          }}
        />
      </Grid>
      
      
      {/* Individual Setting */}
      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Individual Setting</Grid>
      </Grid>
      <Grid container spacing={1} alignItems='center' justifyContent="center">
        <TextField
          id="filled-number"
          name='line_no'
          label="Line No."
          type="number"
          defaultValue={compress.line_no}
          fullWidth
          onChange={handleValue}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{ 
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0,
            max:compress.line_count-1,
            step:1
          }}
        />

        {IndividualSetting()}

      </Grid>
      

      {/* Buttons */}
      <Grid container spacing={1} alignItems='center'>
        {/*
        <Grid item xs={6}>
          <Button className={getDisabled(0) ? style.buttonSelected : style.button} onClick={onCreateCross} disabled={getDisabled(0)}>Create Lines</Button>
        </Grid>
        */}
        <Grid item xs={6}>
          <Button className={getDisabled(0) ? style.buttonDisable : style.button} onClick={onCreateSocket} disabled={getDisabled(0)} size="small" >Create Socket</Button>
        </Grid>
        <Grid item xs={6}>
          <Button className={getDisabled(2) ? style.buttonDisable : style.button} onClick={onClear} disabled={getDisabled(2)} size="small" >Clear Socket</Button>
        </Grid>
      </Grid>

      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={6}>
        </Grid>
      </Grid>
    </div>
  );
}
export default FormCompress;
